import React, { useMemo } from "react";
import SummaryItemDetails from "./SummaryItemDetails";
import { buildBasketItemImageUrl } from "../Utilities/basketImage";
import { useSelector } from "react-redux";
import "../styles/basket.css";

const SummaryItemCalendars = (props) => {
  const basket = useSelector((state) => state.basket.basket);
  const itemId = props.item?.item_id ?? props.id ?? "unknown";
  const imageUrl = useMemo(
    () => buildBasketItemImageUrl(props.item, basket),
    [props.item, basket]
  );

  return (
    <div className="summary_item_container" data-testid={`summary-item-${itemId}`}>
      <div className="basket_item">
        <div
          className="relative flex items-center justify-center overflow-hidden w-basket-img-sm h-basket-img-sm md:w-basket-img-lg md:h-basket-img-lg"
          style={{
            flexShrink: 0,
          }}
          data-testid={`summary-item-image-${itemId}`}
        >
          <img
            src={imageUrl}
            alt={props.item.title || "Product"}
            className="object-contain shadow-[0px_0px_8px_0px_rgba(0,0,0,0.25)] w-full h-full"
          />
        </div>
        <div style={{ flexGrow: 1, marginInlineStart: "24px" }} data-testid={`summary-item-details-wrapper-${itemId}`}>
          <SummaryItemDetails couponsItem={props.couponsItem} />
        </div>
      </div>
    </div>
  );
};
export default SummaryItemCalendars;
